/**
 * app接口
 */
import {appDeleteRequest, appGetRequest, appPostRequest} from "./AppRequest";
import {KEY_NEW_PROJECT_ID} from "@/Const";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";

// 这句，导入的这句 会引起很多问题。这个不能导。不能导 |||  这句，导入的这句 会引起很多问题。这个不能导。不能导
/**
 * 这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导
 * 这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导
 * 这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导这句，导入的这句 会引起很多问题。这个不能导。不能导
 * 很多正常的变量没有被初始化...
 * Cannot access 'SYS_CONFIG_KEY_THEME' before initialization
 * Cannot access 'SYS_CONFIG_KEY_THEME' before initialization
 * Cannot access 'SYS_CONFIG_KEY_THEME' before initialization
 */
// import {mPublishId} from "@/views/Draw/DrawIndex";

/**
 * 列表
 * @param szSort
 */
export const apiProjectList = (isDeleted:any,isFavirated:any)=>{
    var data:any = {
        isDeleted,
    }
    if (isFavirated){
        data.isFavirated = isFavirated
    }
    return appGetRequest("/project/projectList",data,()=>{

    })
}

/**
 * 根据ID获取项目
 */
export const apiProjectById =(szId:string)=>{
    return appGetRequest("/project/projectById",{id:szId},(error:any)=>{

    })
}

/**
 * 取board列表和nores
 * @param szId
 */
export const apiProjectListBoardNotes = (szProjectId:string)=>{
    return appGetRequest("/project/projectListBoardNotes",{projectId:szProjectId},(error:any)=>{

    })
}

/**
 * 一次更新画布上的所有元素....
 * @param project
 * @param arrayBoards
 * @param arrayElements
 */
export const apiUpdateProjectAll = (project:any,arrayBoards:any,arrayElements:any)=>{
    return appPostRequest("/project/updateAll",{project,arrayBoards,arrayElements},(error:any)=>{

    })
}

/**
 * 根据boardId 获取第一个board的元素集合
 * @param szBoardKeyId
 */
export const apiElementByBoardKey = (szBoardKeyId:string)=>{
    return appGetRequest("/element/listElementByBoardId",{boardKeyId:szBoardKeyId},(error:any)=>{

    })
}

/**
 * 单独的元素
 * @param element
 */
export const apiUpdateElement = (projectId:string,selectNode:any,arrayElements:any)=>{
    console.log('******apiUpdateElement******')
    var board = {
        projectId:projectId,//localStorage.getItem(KEY_NEW_PROJECT_ID),
        keyId:selectNode?.key,
        title:selectNode.title,
        isFolder:selectNode.isFolder,
        updateTime:selectNode.updateTime,
        appState:selectNode.drawJson.appState
    }
    return appPostRequest('/element/updateElement', {board,arrayElements},(error:any)=>{

    });
}

/**
 * 根据ID删除元素
 * @param szId
 */
export const apiDeleteElement = (szId:string)=>{
    return appGetRequest('/element/deleteElement',{id:szId},(error:any)=>{

    })
}

/**
 * 根据ID批量删除element
 * @param ids
 */
export const apiElementDeleteByIds = (ids:any)=>{
    return appPostRequest("/element/deleteElementByIds",ids,(error:any)=>{

    })
}

/**
 * 当前画布
 * @param szProjectId
 */
export const apiBoardListByProjectId = (szProjectId:string)=>{
    return appGetRequest("/board/listByProjectId",{projectId:szProjectId},(error:any)=>{

    })
}
/**
 * 画板
 * @param board
 */
export const apiBoardUpdate = (board:any)=>{
    return appPostRequest("/board/updateBoard",board,(error:any)=>{

    })
}

/**
 * 画布
 * @param canvas
 */
export const apiUpdateProject = (project:any)=>{
    return appPostRequest('/project/updateProject',project,(error:any)=>{

    })
}




// /**
//  * library列表
//  */
// export const apiLibraryList = ()=>{
//     return appGetRequest("/library/list",{},(error:any)=>{
//
//     })
// }
// /**
//  * 更新library
//  * @param card
//  */
// export const apiLibraryUpdate = (card:any)=>{
//     return appPostRequest("/library/update",card,(error:any)=>{
//
//     })
// }


/**
 * 标签列表
 */
export const apiTagList = ()=>{
    return appGetRequest("/tag/list",{},(error:any)=>{

    })
}

/**
 * 更新标签
 * @param tag
 */
export const apiTagUpdate = (tag:any)=>{
    return appPostRequest("/tag/update",tag,(error:any)=>{

    })
}

/**
 * 删除卡片
 * @param id
 */
export const apiTagDelete = (id:any)=>{
    return appDeleteRequest('/tag/delete?id='+id,{},(error:any)=>{

    })
}

/**
 * 卡片与project的引用
 * @param arrayProjectCardRef
 */
export const apiProjectCardRefUpdate = (arrayProjectCardRef:any)=>{
    return appPostRequest("/projectCardRef/update",arrayProjectCardRef,(error:any)=>{

    })
}






















